module.exports = __webpack_public_path__ + "static/mujeres008-ca052f5e8b36fe91e67b41777a342cef.jpg";